import React, { useContext, useEffect } from "react";
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import { OverallStatusContext } from "./context/OverallStatusContext";
import { FormattedMessage } from "react-intl";
import { getRefreshInterval } from "../overview/utils/utils";
import { CycleFilterContext } from "../overview/context/CycleFilterContext";
import { getDocumentURL } from "../handler/ParentDataHandler";
import { getBaseUrl } from "../outboundAmzl/util/Util";

const OverallStatusView = () => {
  const { cycles } = useContext(CycleFilterContext);
  const { viewModel, dispatch } = useContext(OverallStatusContext);

  const getData = () => {
    getDocumentURL().then((result) => {
      dispatch({
        type: "LOAD_VIEW",
        data: {
          filter: cycles,
          dispatcher: dispatch,
          baseUrl: getBaseUrl(result),
        },
      });
    });
  };

  useEffect(() => {
    if (cycles.allCycles.length > 0) {
      getData();
      const interval = setInterval(() => {
        if (!document.hidden) {
          getData();
        }
      }, getRefreshInterval());
      return () => clearInterval(interval);
    }
  }, [cycles]);

  return (
    <div>
      <Row width="100%" widths={["grid-4"]} spacingInset="large">
        <div>
          <Heading level={2} type="h400" alignment="left">
            <FormattedMessage
              id="outbound.overall_status"
              defaultMessage="Overall Status"
            />
          </Heading>
          <Row
            width="100%"
            widths={["grid-11", "grid-1"]}
            spacingInset="medium none none"
          >
            <Text type="h100">
              <FormattedMessage
                id="outbound.inducted"
                defaultMessage="Inducted"
              />
            </Text>
            <Text type="b300">{viewModel.inducted}</Text>
          </Row>
          <Row
            width="100%"
            widths={["grid-11", "grid-1"]}
            spacingInset="medium none none"
          >
            <Text type="h100">
              <FormattedMessage id="outbound.picked" defaultMessage="Picked" />
            </Text>
            <Text type="b300">{viewModel.picked}</Text>
          </Row>
          <Row
            width="100%"
            widths={["grid-11", "grid-1"]}
            spacingInset="medium none none"
          >
            <Text type="h100">
              <FormattedMessage id="outbound.stowed" defaultMessage="Stowed" />
            </Text>
            <Text type="b300">{viewModel.stowed}</Text>
          </Row>
          <Row
            width="100%"
            widths={["grid-11", "grid-1"]}
            spacingInset="medium none none"
          >
            <Text type="h100">
              <FormattedMessage id="outbound.staged" defaultMessage="Staged" />
            </Text>
            <Text type="b300">{viewModel.staged}</Text>
          </Row>
          <Row
            width="100%"
            widths={["grid-11", "grid-1"]}
            spacingInset="medium none none"
          >
            <Text type="h100">
              <FormattedMessage
                id="outbound.departed"
                defaultMessage="Departed"
              />
            </Text>
            <Text type="b300">{viewModel.departed}</Text>
          </Row>
          <Row
            width="100%"
            widths={["grid-11", "grid-1"]}
            spacingInset="medium none none"
          >
            <Text type="h100">
              <FormattedMessage
                id="outbound.problemSolve"
                defaultMessage="Problem Solve"
              />
            </Text>
            <Text type="b300">{viewModel.problemSolve}</Text>
          </Row>
        </div>
      </Row>
    </div>
  );
};

export default OverallStatusView;



// WEBPACK FOOTER //
// ./src/components/overallstatus/OverallStatusView.js